import { computed } from 'vue';
import { usePermission } from '@/entities/Permission';

export function useReminderHistoryPermissions() {
  const { can, isLoaded } = usePermission();
  const canReadGeneralHistory = can('readGeneral', 'NoticeHistory');

  return {
    permissionsLoaded: computed(() => isLoaded.value),
    isPermissionsLoading: computed(() => !isLoaded.value),
    canReadGeneralHistory,
  };
}
